import { Injectable } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { Response } from '@angular/http';
import { Actions, Effect } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { AppState } from '../../../reducers';
import { ShoppingCartApi } from '../../../services/webservice'
import { ShoppingCartActions } from '../../shopping-cart/shopping-cart.actions';
import { CheckoutActions, MessageActions, TicketQuotaActions } from '../../../actions';
import { ErrorHandlerService } from '../../../services/index'
import { ActivatedRoute, Router } from '@angular/router';
import { UnsafeAction } from '../../../actions/UnsafeAction';
import { BoxOfficeActions } from 'app/components/box-office/ngrx/box-office.actions';
import { OrderApi } from 'app';
import * as model from "../../../models";

/* tslint:disable */
@Injectable()
export class BoxOfficeEffect {

	constructor(
		private updates$: Actions,
		private store: Store<AppState>,
		private shoppingCartActions: ShoppingCartActions,
		private boxOfficeActions: BoxOfficeActions,
		private messageActions: MessageActions,
		private ticketQuotaActions: TicketQuotaActions,
		private checkoutActions: CheckoutActions,
		private shoppingCartApi: ShoppingCartApi,
		private orderApi: OrderApi,
		private errorHandler: ErrorHandlerService,
	) { }

	@Effect() getMyShoppingCartBoxOffice$ = this.updates$
		.ofType(BoxOfficeActions.GET_MY_SHOPPINGCART_BO)
		.flatMap(action => this.shoppingCartApi.getMyShoppingCart()
			.flatMap(myShoppingCart =>
				Observable.concat(
					[
						this.boxOfficeActions.getMyShoppingCartSuccess(myShoppingCart),
						this.shoppingCartActions.getDisplayShoppingCart(myShoppingCart._links.display.href)
					]
				)
			)
			.catch(error => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))
		)

	@Effect() addTicketsBoxOffice$ = this.updates$
		.ofType(BoxOfficeActions.ADD_TICKETS_BO)
		.do((action) => {
			this.store.dispatch(this.boxOfficeActions.unsetHasErrors());
			return action
		})
		.flatMap((action: UnsafeAction) => this.shoppingCartApi.addTickets(action.payload.url, action.payload.ticketCreationDTOs)
			.map(shoppingCart => this.shoppingCartActions.getMyShoppingCart())
			.catch(error =>
				Observable.concat(
					[
						this.handleErrorAsAction(error, "Es ist ein unerwarteter Fehler aufgetreten."),
						this.boxOfficeActions.setHasErrors(),
						this.ticketQuotaActions.reloadTicketQuota(action.payload.selectedTicketQuotaId),
					]
				)
			)
		)
	
	@Effect() addVisualBulkTicketsBoxOffice$ = this.updates$
		.ofType(BoxOfficeActions.ADD_VISUAL_BULK_TICKETS_BO)
		.do((action: UnsafeAction) => {
			this.store.dispatch(this.boxOfficeActions.unsetHasErrors());
			this.ticketQuotaActions.reloadTicketQuota(action.payload.selectedTicketQuotaId);
			return action
		})
		.flatMap((action: UnsafeAction) => this.shoppingCartApi.addVisualBulkTickets(action.payload.url, action.payload.ticketCreationDTOs)
			.map(shoppingCart => this.shoppingCartActions.getMyShoppingCart())
			.catch(error =>
				Observable.concat(
					[
						this.handleErrorAsAction(error, "Es ist ein unerwarteter Fehler aufgetreten."),
						this.boxOfficeActions.setHasErrors(),
						this.ticketQuotaActions.reloadTicketQuota(action.payload.selectedTicketQuotaId),
					]
				)
			)
		)

	@Effect() removeTicketsBoxOffice$ = this.updates$
		.ofType(BoxOfficeActions.REMOVE_TICKETS_BO)
		.flatMap((action: UnsafeAction) => this.shoppingCartApi.removeTickets(action.payload.url, action.payload.ticketItemUuids)
			.map(shoppingCart => this.shoppingCartActions.getMyShoppingCart())
		)

	@Effect() deleteShoppingCartBoxOffice$ = this.updates$
		.ofType(BoxOfficeActions.DELETE_SHOPPINGCART_BO)
		.withLatestFrom(this.store)
		.flatMap(([action, store]: [UnsafeAction, AppState]) => this.shoppingCartApi.deleteShoppingCart(action.payload)
			.flatMap(response => {
				return Observable.concat([
					this.shoppingCartActions.deleteShoppingCartSuccess(),
					this.shoppingCartActions.getMyShoppingCart(),
				])
			})
			.catch(error => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))
		)

	@Effect() placeOrderBoxOffice$ = this.updates$
		.ofType(BoxOfficeActions.PLACE_ORDER_BO)
		.flatMap((action: UnsafeAction) => this.orderApi.createOrder(action.payload))
		.map(order => this.boxOfficeActions.orderPlacedBoxOffice(order))

		@Effect() orderPlacedBoxOffice$ = this.updates$
		.ofType(BoxOfficeActions.ORDER_PLACED_BO)
		.flatMap((action: UnsafeAction) => Observable.concat([
			this.boxOfficeActions.getMyShoppingCartBoxOffice(),
			this.boxOfficeActions.completePaymentBoxOffice(action.payload.uuid)
		])).do(() => {
			this.store.dispatch(this.messageActions.displayMessage("Die Bestellung wurde erfolgreich aufgegeben.", "success"))
		})

	@Effect() completePaymentBoxOffice$ = this.updates$
		.ofType(BoxOfficeActions.COMPLETE_PAYMENT_BO)
		.flatMap((action: UnsafeAction) => this.orderApi.confirmePayment(action.payload))
		.withLatestFrom(this.store)
		.flatMap(([order, store]: [model.Order, AppState]) => Observable.concat([
			this.checkoutActions.orderPaid(order),
		]))
		/* redirect to seating plan after odering no needed now
		.do(() => {
			this.store.select('eventServerState', 'event', 'currentEvent').take(1).subscribe(
				(event) => {
					if(event.userSetHasVisualQuota){
						this.router.navigate(["seatingplan-sale-box-office", event.storageId])}
						this.store.dispatch(this.messageActions.displayMessage("Die Bestellung wurde erfolgreich aufgegeben.", "success"))
				}
			).unsubscribe()
		})*/

	private handleError(error:Response, defaultMessage:string):Observable<Action> {
		let errorMessage = this.errorHandler.getErrorMessage(error,	defaultMessage)
		return Observable.of(this.messageActions.displayMessage(errorMessage, "error"))
	}

	private handleErrorAsAction(error: Response, defaultMessage: string): Action {
		let errorMessage = this.errorHandler.getErrorMessage(error, defaultMessage)
		return this.messageActions.displayMessage(errorMessage, "error");
	}
}



// WEBPACK FOOTER //
// ./src/app/components/box-office/ngrx/box.office.effect.ts